import * as React from 'react'
import { IStateMetadata, IServiceLocationObject, IServiceDesignatedHotspot } from '../types'
import { IGoogleMapBoundsDTO, ICoordinatesWithShortKeyDTO } from '../types/google-map'
import UIMessages from '../utils/ui-messages'
import Modal from './ui/Modal'
import { displacementBetween, validateMarkerPosition } from '../utils/location'
import ServiceDesignatedHotspotMapView from './ServiceDesignatedHotspotMapView'

export interface IPinLocationModalProps {
  zoom: number
  bounds: IGoogleMapBoundsDTO
  locations: any[]
  location: IServiceDesignatedHotspot
  locationType?: string
  metadata?: IStateMetadata
  onCancel: () => void
  saveLocation: (location: IServiceDesignatedHotspot) => void
  updateLocation?: (location: IServiceLocationObject) => void
}

interface IPinLocationModalState {
  isSaving: boolean
  currentError: { isError: boolean; message: string }
  location: any
  searchedCoordinates: ICoordinatesWithShortKeyDTO
  autoCompleteLocations: IServiceDesignatedHotspot[]
}

interface IProps {
  isSaving: boolean
  onCancel: () => void
  onSave: () => void
}
//Declaration of radius (CIRCLE)
// const LOCATION_RANGE = 2500 // Maximum drag distance in meters

const BottomBar = ({ onCancel, isSaving, onSave }: IProps) => {
  return (
    <div className='flex col-12 flex bg-light-grey2 py1'>
      <div style={{ flex: 1 }} className='flex-row flex justify-end mr2'>
        <button
          type='button'
          className='SaveButton inline-block btn border-white font-dark-grey rounded font-white weight-300 mt-auto mb-auto mr4'
          onClick={onCancel}
        >
          {UIMessages.common.close}
        </button>
        <button
          type='button'
          className='SaveButton inline-block btn bg-green rounded font-white weight-300 mt-auto mb-auto'
          onClick={onSave}
        >
          {isSaving ? UIMessages.common.saving : UIMessages.common.save}
        </button>
      </div>
    </div>
  )
}

class ServiceDesignatedPinLocationModal extends React.Component<IPinLocationModalProps, IPinLocationModalState> {
  public state = {
    isSaving: false,
    location: { ...this.props.location },
    searchedCoordinates: { ...this.props.location.coordinates },
    currentError: { isError: false, message: '' },
    autoCompleteLocations: [],
    radius: this.props.location.radius
  }

  public componentDidUpdate(prevProps: IPinLocationModalProps) {
    if (prevProps.metadata !== this.props.metadata) {
      if (this.props.metadata && this.props.metadata.processingError) {
        this.showMessage(this.props.metadata.processingError, true)
      }
      if (this.props.metadata && this.props.metadata.processingSuccess) {
        this.showMessage(this.props.metadata.processingSuccess, false)
      }
    }
  }

  public render() {
    console.log(this.state.location)
    const { message, isError } = this.state.currentError
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='col-8 bg-white'>
            {message.length > 0 && (
              <div className={'pr1 pl3 pt1 pb1 font-white ' + (isError ? 'bg-red' : 'bg-green')}>{message}</div>
            )}
            <div className='px2 pt2 map-container'>
              <ServiceDesignatedHotspotMapView
                origin={null}
                destination={null}
                center={this.state.location.coordinates}
                zoom={this.props.zoom}
                polyline={null}
                bounds={this.props.bounds}
                renderStrategyStage=''
                location={this.state.location}
                selectLocation={this.selectLocation}
                circles={this.circleDetails()}
                isModal={true}
                isDraggable={true}
                zones={{}}
              />
            </div>
            <BottomBar onCancel={this.props.onCancel} isSaving={this.state.isSaving} onSave={this.onSave} />
          </div>
        </div>
      </Modal>
    )
  }

  private circleDetails = () => [
    {
      center: this.state.searchedCoordinates,
      radius: this.state.location.radius,
      defaultOptions: {
        fillOpacity: 0.0,
        fillColor: '#FF5733'
      }
    }
  ]

  private selectLocation = async (coordinates: ICoordinatesWithShortKeyDTO, event: google.maps.MouseEvent) => {
    const dwLocations = displacementBetween(this.state.searchedCoordinates, coordinates)
    const { location } = this.state
    // Check if the marker is drag inside the hotspot zone(polygon)
    const isMarkerPositionValid = validateMarkerPosition({ dragEvent: event, location })
    if (dwLocations <= location.radius! || isMarkerPositionValid || 0) {
      location.coordinates = { ...coordinates }
    } else {
      location.coordinates = { ...location.coordinates }
    }
    this.setState({
      location: { ...location }
    })
  }

  private onSave = () => {
    const { location, currentError } = this.state
    if (currentError.isError) {
      console.log('ERRORRRR', currentError.isError)
      return
    }

    this.showMessage('', false)
    this.setState({ isSaving: true })
    this.props.saveLocation(location)
  }

  private showMessage = (message: string, isError: boolean) => {
    if (this.state.currentError.message === message) {
      return
    }
    this.setState({ currentError: { message, isError }, isSaving: false })
  }
}

export default ServiceDesignatedPinLocationModal



// WEBPACK FOOTER //
// ./src/components/ServiceDesignatedPinLocationModal.tsx